import React from "react";
import "./ControlsRow.css";

const ControlsRow = ({ children, horizontalOnMobile = false}) => {
  return (
    <div className="controls-wrapper">
        <div className={horizontalOnMobile ? "horizontal-controls-container" : "controls-container"}>
          {React.Children.map(children, (child) => (
            <div className="control-group">
              {child}
            </div>
          ))}
        </div>
    </div>
  );
}

export { ControlsRow }
